module.exports = __webpack_public_path__ + "assets/img/S_icon.4a6d364c.png";